module.exports = __webpack_public_path__ + "static/ARTS_IMAGE_1-f3be33b96e0e183db3a3487d19e51b81.jpg";